const Footer = () => {
    return(
        <footer className="bc-footer">
            <p>Copyright © { new Date().getFullYear() } Grupo Bancolombia - Todos los derechos reservados - Vicepresidencia de mercadeo</p>
        </footer>
    )
}

export default Footer